<template>
  <div>
    <div class="pa-3" style="display: flex">
      <h1>Campaign Review Banefit</h1>
      <v-divider vertical class="mx-3 hidden-xs-only"></v-divider>
      <v-btn
        color="primary"
        style="color: black"
        class="hidden-xs-only"
        @click="
          formDialog = true;
          editedIndex = -1;
        "
        ><v-icon color="black" class="pr-1">add</v-icon> More Campaign
      </v-btn>
      <v-btn
        class="hidden-sm-and-up"
        color="primary"
        fab
        fixed
        style="bottom: 50px; right: 25px"
        @click="
          formDialog = true;
          editedIndex = -1;
        "
        ><v-icon size="28" color="black">add</v-icon>
      </v-btn>
    </div>
    <v-layout row style="margin-bottom: 10px">
      <v-flex xs12>
        <v-toolbar flat class="pa-2">
          <v-layout wrap
            ><v-flex xs12 sm8 class="pa-1">
              <v-text-field
                v-model="filterConfig.keyword"
                prepend-icon="search"
                label="Name, Description"
                single-line
                hide-details
                class="pa-0"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 class="pa-1">
              <v-select
                prepend-icon="mdi-filter"
                single-line
                hide-details
                :items="provinceData"
                item-text="province_name_th"
                item-value="province_id"
                class="pa-0"
                label="Province"
                v-model="filterConfig.provinceId"
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :expand="true"
      style="border: 1px solid black"
      :headers="headers"
      :loading="is_loading_store"
      :items="filteredCampaignLists"
      item-key="campaign_review_id"
      :rows-per-page-items="[
        25,
        50,
        100,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
      ]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" width="10%">{{ props.index + 1 }}</td>
        <td class="text-xs-center">
          {{ props.item.campaign_review_name_th }}
          <span style="color: grey" v-if="props.item.campaign_review_name_en"
            >({{ props.item.campaign_review_name_en }})</span
          >
        </td>

        <td class="text-xs-center">
          {{ props.item.campaign_review_description_th }}
          <span
            style="color: grey"
            v-if="props.item.campaign_review_description_en"
            >({{ props.item.campaign_review_description_en }})</span
          >
        </td>
        <td width="20%">
          <div v-if="props.item.campaign_review_province.length == 0">
            All Province
          </div>
          <ul v-else>
            <li
              v-for="(province_id, index) in props.item
                .campaign_review_province"
              :key="index"
            >
              {{ showProvinceName(province_id) }}
            </li>
          </ul>
        </td>
        <td class="text-xs-center">
          {{ props.item.campaign_review_start_date }}
        </td>
        <td class="text-xs-center">
          {{ props.item.campaign_review_end_date }}
        </td>
        <td class="text-xs-center">
          {{ props.item.campaign_review_amount_redeemed }}/{{
            props.item.campaign_review_total_amount
          }}
        </td>
        <td class="text-xs-center">
          <v-switch
            hide-details
            v-model="props.item.campaign_review_active"
            color="primary"
            :true-value="1"
            :false-value="0"
            @change="changeState(props.item)"
          ></v-switch>
        </td>
        <td class="text-xs-center">
          <v-btn
            icon
            :to="`/weserve_admin_login/-/maindinein/dinein-review-benefit/${props.item.campaign_review_id}/logtable`"
            ><v-icon size="20">remove_red_eye</v-icon></v-btn
          >
        </td>
        <td width="10%">
          <v-btn @click="props.expanded = !props.expanded" icon>
            <v-icon
              >{{
                props.expanded == true
                  ? "mdi-chevron-up-circle"
                  : "mdi-chevron-down-circle"
              }}
            </v-icon></v-btn
          >
        </td>
        <td class="text-xs-center" style="white-space: nowrap">
          <v-btn icon @click="toEdit(props.item, props.index)"
            ><v-icon size="20">mdi-pencil</v-icon></v-btn
          >
          <v-btn
            icon
            @click="deleteCampaignReview(props.item.campaign_review_id)"
            :loading="deletingIndex.includes(props.item.campaign_review_id)"
            ><v-icon size="20" color="red">mdi-delete</v-icon></v-btn
          >
        </td>
      </template>
      <template v-slot:expand="props">
        <div style="display: flex; background-color: #f9f9f9">
          <v-layout wrap justify-center
            ><v-flex
              xs12
              sm4
              v-for="(rank, index) in props.item.campaign_review_level"
              :key="index"
            >
              <v-card
                :color="
                  rank.rank_name == 'standard'
                    ? '#ebfff5'
                    : rank.rank_name == 'silver'
                    ? '#f2f2f2'
                    : rank.rank_name == 'gold'
                    ? '#fff2bb'
                    : rank.rank_name == 'platinum'
                    ? '#eef8ff'
                    : rank.rank_name == 'vip'
                    ? '#f2f2f2'
                    : ''
                "
                class="ma-3"
                flat
                :style="{
                  border:
                    rank.rank_name == 'standard'
                      ? '1.5px solid #09d377'
                      : rank.rank_name == 'silver'
                      ? '1.5px solid #666666'
                      : rank.rank_name == 'gold'
                      ? '1.5px solid #ff9f00'
                      : rank.rank_name == 'platinum'
                      ? '1.5px solid #1185f3'
                      : rank.rank_name == 'vip'
                      ? '1.5px solid #bd9c17'
                      : '',
                }"
              >
                <v-card-title
                  :style="{
                    color:
                      rank.rank_name == 'standard'
                        ? '#09d377'
                        : rank.rank_name == 'silver'
                        ? '#666666'
                        : rank.rank_name == 'gold'
                        ? '#ff9f00'
                        : rank.rank_name == 'platinum'
                        ? '#1185f3'
                        : rank.rank_name == 'vip'
                        ? '#bd9c17'
                        : '',
                  }"
                >
                  {{ rank.rank_name.toUpperCase() }}</v-card-title
                >
                <v-divider
                  :color="
                    rank.rank_name == 'standard'
                      ? '#09d377'
                      : rank.rank_name == 'silver'
                      ? '#666666'
                      : rank.rank_name == 'gold'
                      ? '#ff9f00'
                      : rank.rank_name == 'platinum'
                      ? '#1185f3'
                      : rank.rank_name == 'vip'
                      ? '#bd9c17'
                      : ''
                  "
                ></v-divider>
                <v-card-text>
                  <div>
                    <span class="pr-1" style="font-weight: bold">
                      ส่วนลดรีวิวแบบไม่เขียนรีวิว / ไม่ใส่รูปภาพ =
                    </span>
                    <span v-if="rank.rank_review_normal_amount > 0"
                      >{{ rank.rank_review_normal_amount }}
                      {{
                        rank.rank_review_normal_unit == "baht"
                          ? "บาท"
                          : rank.rank_review_normal_unit == "percentage"
                          ? "%"
                          : ""
                      }}</span
                    >
                    <span v-else>ไม่ได้รับสิทธิพิเศษ</span>
                  </div>
                  <div>
                    <span class="pr-1" style="font-weight: bold">
                      ส่วนลดรีวิวแบบไม่เขียนรีวิว / ใส่รูปภาพ =
                    </span>
                    <span v-if="rank.rank_review_with_image_amount > 0"
                      >{{ rank.rank_review_with_image_amount }}
                      {{
                        rank.rank_review_with_image_unit == "baht"
                          ? "฿"
                          : rank.rank_review_with_image_unit == "percentage"
                          ? "%"
                          : ""
                      }}</span
                    >
                    <span v-else>ไม่ได้รับสิทธิพิเศษ</span>
                  </div>
                  <div>
                    <span class="pr-1" style="font-weight: bold">
                      ส่วนลดรีวิวแบบเขียนรีวิว / ไม่ใส่รูปภาพ =
                    </span>
                    <span v-if="rank.rank_review_normal_with_text_amount > 0"
                      >{{ rank.rank_review_normal_with_text_amount }}
                      {{
                        rank.rank_review_normal_with_text_unit == "baht"
                          ? "฿"
                          : rank.rank_review_normal_with_text_unit ==
                            "percentage"
                          ? "%"
                          : ""
                      }}</span
                    >
                    <span v-else>ไม่ได้รับสิทธิพิเศษ</span>
                  </div>
                  <div>
                    <span class="pr-1" style="font-weight: bold">
                      ส่วนลดรีวิวแบบเขียนรีวิว / ใส่รูปภาพ =
                    </span>
                    <span
                      v-if="rank.rank_review_with_image_with_text_amount > 0"
                      >{{ rank.rank_review_with_image_with_text_amount }}
                      {{
                        rank.rank_review_with_image_with_text_unit == "baht"
                          ? "฿"
                          : rank.rank_review_with_image_with_text_unit ==
                            "percentage"
                          ? "%"
                          : ""
                      }}</span
                    >
                    <span v-else>ไม่ได้รับสิทธิพิเศษ</span>
                  </div>
                </v-card-text>
              </v-card></v-flex
            ></v-layout
          >
        </div>
      </template>
      <template slot="no-data">
        <div v-if="is_loading_store == true" class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else class="text-xs-center">No data available</div>
      </template>
    </v-data-table>
    <v-dialog v-model="error_dialog" persistent max-width="500">
      <v-card>
        <div
          style="
            background-color: #fddf00;
            height: 60px;
            display: flex;
            align-items: center;
            padding-left: 20px;
          "
        >
          <v-icon large style="margin-right: 10px" color="black"
            >warning</v-icon
          >
          <div style="font-size: 1.8rem">Warning</div>
        </div>
        <v-card-title class="headline" primary-title>
          Something went wrong, please try again.
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <formReviewBanefit
      :dialog="formDialog"
      :editedIndex="editedIndex"
      @onClosed="formDialog = false"
      @onSaved="onSavedForm"
      :selectedItem="selectedItem"
    ></formReviewBanefit>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import formReviewBanefit from "@/components/back-office/DineIn/Review/formReviewBanefit.vue";
export default {
  data: () => ({
    filterConfig: {
      provinceId: undefined,
      keyword: "",
    },
    formDialog: false,
    editedIndex: -1,
    deletingIndex: [],
    is_loading_store: false,
    error_dialog: false,
    selectedItem: {},
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Name",
        align: "center",
        sortable: false,
      },
      {
        text: "Description",
        align: "center",
        sortable: false,
      },
      {
        text: "Province",
        align: "center",
        sortable: false,
      },
      {
        text: "Start",
        align: "center",
        sortable: false,
      },
      {
        text: "End",
        align: "center",
        sortable: false,
      },
      {
        text: "Remaining",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        sortable: false,
      },
      {
        text: "Log",
        align: "center",
        sortable: false,
      },
      {
        text: "More Detail",
        align: "center",
        sortable: false,
      },
      {
        text: "",
        align: "center",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapState({
      campaign_review_benefit_list: (state) =>
        state.fetchDineIn.campaign_review_benefit_list,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    filteredCampaignLists() {
      return this.campaign_review_benefit_list.filter(
        (val) =>
          (this.filterConfig.provinceId != undefined &&
            val.campaign_review_province.includes(
              this.filterConfig.provinceId
            )) ||
          val.campaign_review_name_th
            .toLowerCase()
            .includes(this.filterConfig.keyword.toLowerCase()) ||
          val.campaign_review_name_en
            .toLowerCase()
            .includes(this.filterConfig.keyword.toLowerCase())
      );
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions({
      fetchCampaignReviewBenefit: "fetchDineIn/fetchCampaignReviewBenefit",
      createCampaignReviewBenefit: "fetchDineIn/createCampaignReviewBenefit",
      changeStatusCampaignReview: "fetchDineIn/changeStatusCampaignReview",
      removeCampaignReviewBenefit: "fetchDineIn/removeCampaignReviewBenefit",
      updateCampaignReviewBenefit: "fetchDineIn/updateCampaignReviewBenefit",
    }),
    moment,
    toEdit(item, index) {
      this.selectedItem = item;
      this.editedIndex = index;
      this.formDialog = true;
    },
    async changeState(item) {
      var res = await this.changeStatusCampaignReview(item.campaign_review_id);
      if (res == true) return;
      if (item.campaign_review_active == 1) item.campaign_review_active = 0;
      if (item.campaign_review_active == 0) item.campaign_review_active = 1;
      this.error_dialog = true;
    },
    showProvinceName(province_id) {
      try {
        let province = this.provinceData.find(
          (val) => val.province_id == province_id
        );
        return province.province_name_th;
      } catch (e) {
        return "";
      }
    },
    async fetchData() {
      this.is_loading_store = true;
      await this.fetchCampaignReviewBenefit();
      this.is_loading_store = false;
    },
    async onSavedForm(e) {
      let result = false;
      if (this.editedIndex == -1) {
        result = await this.createCampaignReviewBenefit(e.form);
      } else {
        result = await this.updateCampaignReviewBenefit(e.form);
      }
      if (result == false) this.error_dialog = true;
      this.formDialog = false;
      e.done();
    },
    showDayCountingString(minutes) {
      let hours = Math.floor(minutes / 60);
      let day = Math.floor(hours / 24);
      hours = hours - day * 24;
      let minute = minutes - hours * 60 - day * 24 * 60;

      let daysString = "";
      if (day > 0) {
        daysString = `${day} วัน`;
      }
      if (hours > 0) {
        daysString += ` ${hours} ชั่วโมง`;
      }
      if (minute > 0) {
        daysString += ` ${minute} นาที`;
      }
      return daysString;
    },
    async deleteCampaignReview(campaign_review_id) {
      let n = await this.$confirm("Do you want to delete this campaign ?");
      if (n == false) return;
      this.deletingIndex.push(campaign_review_id);
      await this.removeCampaignReviewBenefit(campaign_review_id);
      let index = this.deletingIndex.findIndex(
        (val) => val == campaign_review_id
      );
      this.deletingIndex.splice(index, 1);
    },
  },
  components: {
    formReviewBanefit,
  },
};
</script>
